import React from 'react';
import './App.css';
import TodoContainer from './components/TodoContainer';
import ITodo from './interfaces/ITodo';
import { alertToastSucess, alertToastWarning, confirmDelete } from './assets/Alerts';

const App = () => {

  const preferences = {
    colorMode: 'light',
    lastState: 'all',
    lastTodo: '',
    lastId: 0
  }

  const toggleColor = () => {
    document.body.classList.toggle("light");
    preferences.colorMode = preferences.colorMode === "light" ? "dark" : "light";
    localStorage.setItem("settings", JSON.stringify(preferences));
  }

  // Si no recibe un array al cual aplicar filtra el global.
  const applyFilter = (filter: string, localeTodos: Array<ITodo> = todos) => {
    setFilter(filter);
    setLastState(filter)

    switch (filter) {
      case "completed":
        return localeTodos.filter((todo) => todo.completed)

      case "pending":
        return localeTodos.filter((todo) => !todo.completed)

      default:
        return localeTodos;
    }
  }

  const setLastState = (state: string) => {
    preferences.lastState = state;
    localStorage.setItem("settings", JSON.stringify(preferences));
  }

  const filterAll = () => {
    setFilteredTodos(applyFilter('all'));
    getPending();
  }

  const filterPending = () => {
    setFilteredTodos(applyFilter('pending'));
    getPending();
  }

  const filterCompleted = () => {
    setFilteredTodos(applyFilter('completed'));
    getPending();
  }

  const clearCompleted = () => {
    const clearedTodos = todos.filter((todo: any) => !todo.completed);
    setFilteredTodos(applyFilter(filter, clearedTodos));
    setTodos(clearedTodos);

    addTodosToMemory(clearedTodos);
  }

  const getPending = (localeTodos: Array<ITodo> = todos) => {
    setPending(localeTodos.reduce((n, todo) => todo.completed ? n + 0 : n + 1, 0));
  }

  const addTodosToMemory = (todos: any) => {
    localStorage.setItem('todos', JSON.stringify(todos))
  }

  const saveTodo = (e: any) => {

    if(newTodo.length < 1){
      return alertToastWarning(preferences.colorMode);
    }
    
    preferences.lastId = preferences.lastId + 1;

    const todo: ITodo = {
      id: preferences.lastId,
      content: newTodo,
      completed: false
    }

    changeNewTodo('')

    Array.from(document.querySelectorAll(".app__input")).map((input: any) => input.value = "");

    const newTodoState = [...todos, todo]

    setTodos(newTodoState)
    setFilteredTodos(applyFilter(filter, newTodoState));

    getPending(newTodoState);

    preferences.lastTodo = '';
    localStorage.setItem("settings", JSON.stringify(preferences));
    addTodosToMemory(newTodoState);
  }

  const handleTodo = (e: any) => {
    changeNewTodo(e.target.value);
  };

  const changeNewTodo = (content: string) => {
    setNewTodo(content);
  };

  const handleTodoOut = (e: any) => {
    preferences.lastTodo = newTodo;
    localStorage.setItem("settings", JSON.stringify(preferences));
  }

  const loadPreferences = () => {
    const settings = JSON.parse(`${localStorage.getItem('settings')}`);

    if (settings) {
      preferences.colorMode = settings.colorMode
      preferences.lastState = settings.lastState;
      preferences.lastTodo = settings.lastTodo;
      preferences.lastId = settings.lastId;
    }

    if (preferences.colorMode === 'light') {
      document.body.classList.add("light")
    }
  }

  const loadTodos = () => {
    const savedTodos = JSON.parse(`${localStorage.getItem("todos")}`);
    return savedTodos ? savedTodos : [];
  }

  const ifFilterTodos = (filter: string) => {

    let savedTodos = JSON.parse(`${localStorage.getItem("todos")}`);

    if (!savedTodos) {
      savedTodos = [];
    }

    switch (filter) {
      case "completed":
        return savedTodos.filter((todo: any) => todo.completed)

      case "pending":
        return savedTodos.filter((todo: any) => !todo.completed)

      default:
        return savedTodos;
    }
  }

  loadPreferences();

  const [newTodo, setNewTodo] = React.useState(preferences.lastTodo);
  const [filter, setFilter] = React.useState("all");
  const [pending, setPending] = React.useState(0);
  const [filteredTodos, setFilteredTodos] = React.useState(ifFilterTodos(preferences.lastState));
  const [todos, setTodos] = React.useState(loadTodos())

  const handleEndTodo = (e: any) => {
    const activated = e.target.closest(".input-group")?.childNodes[0];
    
    if(e.target.className === 'input-group__delete-btn'){
      const newTodosState = todos.filter((e: any) => e.id != activated.id.split('-')[1])

      confirmDelete(preferences.colorMode).then((result) => {
        if (result.isConfirmed) {
          alertToastSucess(preferences.colorMode)

          setFilteredTodos(applyFilter(filter, newTodosState));
          setTodos(newTodosState);
          getPending(newTodosState);
          addTodosToMemory(newTodosState);
        }
      });

      return
    }

    if (activated) {
      const newTodosState = todos.map((e: any) => {
        e.id == activated.id.split('-')[1] && (e.completed = activated.checked)
        return e;
      }
      )

      setFilteredTodos(applyFilter(filter, newTodosState));
      setTodos(newTodosState);
      getPending();
      addTodosToMemory(newTodosState);
    }
  }

  return (
    <div className="app__body">
      <div className="app__container">
        <div className="app__title-container">
          <h1 className="app__title">  Todo </h1>
          <button className="app__toggle-color" onClick={toggleColor} aria-label="Toggle-color-mode"></button>
        </div>

        <div className="input-group">
          <input className="app__input" type="text" placeholder="Create a new todo..." onChange={handleTodo} onBlur={handleTodoOut} defaultValue={newTodo} />
          <button className="app__save-todo" onClick={saveTodo} aria-label="Save-todo"></button>
        </div>
        <div className="app__todo-container">

          <div className="app__upper-section" id='app__upper-section' onClick={handleEndTodo} >
            <TodoContainer todos={filteredTodos} ></TodoContainer>
          </div>

          <div className="app__lower-section">
            <span className="app__items-left">{pending} items left</span>

            <div className="app__filter-state">
              <input type="radio" name="state" id="all" className="app__state-check" hidden defaultChecked={preferences.lastState === 'all'} />
              <label htmlFor="all" className="app__state-label" onClick={filterAll}>All</label>
              <input type="radio" name="state" id="active" hidden className="app__state-check" defaultChecked={preferences.lastState === 'pending'} />
              <label htmlFor="active" className="app__state-label" onClick={filterPending}>Active</label>
              <input type="radio" name="state" id="completed" hidden className="app__state-check" defaultChecked={preferences.lastState === 'completed'} />
              <label htmlFor="completed" className="app__state-label" onClick={filterCompleted}>Completed</label>
            </div>
            <span className="app__clear-completed" onClick={clearCompleted}> Clear Completed</span>

          </div>
        </div>
        <p className="app__bottom-message">
          {/*Drag and drop to reorder list*/}
        </p>

      </div>
    </div>
  );
}

export default App;